<template>
  <sc-card
    class="page-logs-tracking-event-header-event"
    v-if="showBox">
    <template slot="header">
      <h2 class="has-text-primary is-size-4 card-header-title">Evento</h2>
    </template>

    <template slot="body">
      <p
        class="heading"
        v-if="event.event_source">
        <strong>Tipo:</strong>
        <span>{{ typeEventLabel(event.event_source) }}</span>
      </p>

      <p
        class="heading"
        v-if="event.internal_event_code">
        <strong>Código Interno:</strong>
        <span>{{ event.internal_event_code }}</span>
      </p>

      <p
        class="heading"
        v-if="event.external_event_code">
        <strong>Código externo:</strong>
        <span>{{ event.external_event_code }}</span>
      </p>

      <p
        class="heading"
        v-if="event.event_date">
        <strong>Data do evento:</strong>
        <span>{{ event.event_date | date('DD/MM/YYYY HH:mm:ss') }}</span>
      </p>

      <p
        class="heading"
        v-if="event.generated_event_code">
        <strong>Evento Pai:</strong>
        <span>{{ event.generated_event_code }}</span>
      </p>
    </template>
  </sc-card>
</template>

<script>
  import { ScCard } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapGetters } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'sc-logs-tracking-detail-header-event',
    computed: {
      ...mapState([
        'event',
      ]),
      ...mapGetters([
        'typeEventLabel',
      ]),
      showBox() {
        return !!this.event.event_source ||
          !!this.event.internal_event_code ||
          !!this.event.external_event_code ||
          !!this.event.event_date;
      },
    },
    components: {
      ScCard,
    },
  };
</script>

<style lang="scss" scoped>
  .page-logs-tracking-event-header-event {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/components/sc-logs-tracking-detail-header/blocks/sc-logs-tracking-detail-header-event/ScLogsTrackingDetailHeaderEvent.vue?58bb94bc